import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

const cn = (...inputs: ClassValue[]) => clsx(inputs);
cn.withMerge = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export { cn };
